import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import useMediaQuery from '@mui/material/useMediaQuery';

import T from 'shared/atoms/Typography';

import theme from 'shared/themes/default';

import AllOrganizationsOverViewTable from './AllOrganizationsOverViewTable';
import EpisodesSeenGraph from './EpisodesSeenGraph';
import TableWithSearchAndExport from './TableWithSearchAndExport';

import { useWatchData } from '../Context';
import {
  listAggregatedWatchData,
  listOrganizationsWatchData,
} from '../Context/graphql/queries';

const Wrapper = styled.div`
  max-width: 100%;
`;

const ShowOrganizationsData = () => {
  const isMobile = useMediaQuery(theme.breakpoints.mobile);

  const { t } = useTranslation();
  const {
    restClient,
    selectOrganizationHandler,
    setWatchDataError,
    useLazyGraphQLQuery,
  } = useWatchData();

  const [listAggregatedWatchDataQuery, listAggregatedWatchDataResponse] =
    useLazyGraphQLQuery(listAggregatedWatchData);
  const [listOrganizationsWatchDataQuery, listOrganizationsWatchDataResponse] =
    useLazyGraphQLQuery(listOrganizationsWatchData);

  const aggregatedWatchData =
    listAggregatedWatchDataResponse.data?.listAggregatedWatchData || [];

  useEffect(() => {
    listAggregatedWatchDataQuery({
      variables: {
        filter: {
          organizationId: 'all',
        },
      },
    });
    listOrganizationsWatchDataQuery();
  }, []);

  useEffect(() => {
    const { error } = listAggregatedWatchDataResponse;

    if (error) {
      setWatchDataError(true);
    }
  }, [listAggregatedWatchDataResponse]);

  useEffect(() => {
    const { error } = listOrganizationsWatchDataResponse;

    if (error) {
      setWatchDataError(true);
    }
  }, [listOrganizationsWatchDataResponse]);

  const organizations =
    listOrganizationsWatchDataResponse.data?.listOrganizationsWatchData
      ?.map((item) => ({
        ...item,
        value: item.id,
      }))
      .filter((item) => item.name)
      .sort((a, b) => {
        return a.name?.localeCompare(b.name);
      }) || [];

  return (
    <Wrapper>
      <T
        color={theme.palette.brand}
        fontWeight="medium"
        phoneVariant="headingXs"
        sx={{
          marginBottom: theme.spacing.m3,
          marginTop: isMobile ? theme.spacing.xl : theme.spacing['2xl'],
        }}
        variant="headingS"
      >
        {t('watchData.titleAllOrganizations')}
      </T>
      <EpisodesSeenGraph
        data={aggregatedWatchData}
        loading={listAggregatedWatchDataResponse.loading}
        spinnerDuration={10}
      />
      <TableWithSearchAndExport
        itemsToDisplay={organizations}
        downloadItems={() => restClient.get(`/watchData/organizations`)}
        tableTitle={t('watchData.activityOfOrganizations')}
        searchPlaceHolder={t('watchData.searchForOrganizations')}
        TableToDisplay={AllOrganizationsOverViewTable}
        tableProps={{ selectOrganizationHandler }}
        showRowsAreClickableMessage
        loading={
          listOrganizationsWatchDataResponse.loading || !organizations.length
        }
        spinnerDuration={20}
        emptyMessage={t('watchData.noActivity')}
      />
    </Wrapper>
  );
};

export default ShowOrganizationsData;
